<template>
    <transition name="layout-fade">
        <loader v-if="loader"/>
        <v-layout wrap column class="layout-add layout-add--max_width" v-else>
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Редактировать категорию</v-toolbar-title>
                <v-spacer/>
                <v-btn color="info" class="v-btn--save" :loading="loading" :disabled="loading" @click="sendForm">
                    Сохранить
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
                <v-btn color="error" class="v-btn--save" @click="dialog = true">
                    Удалить
                </v-btn>
            </v-toolbar>
            <v-form class="form-add">
                <v-flex xs12>
                    <v-subheader class="pa-0">Название</v-subheader>
                    <v-text-field
                        ref="category_name"
                        v-model="category.name"
                        v-validate="'required|max:50'"
                        data-vv-name="name"
                        :error-messages="errors.collect('name')"
                        single-line
                        solo
                        text
                        required/>
                </v-flex>
                <v-flex xs12 mb-4>
                    <v-layout>
                        <upload-img :image-width="1024" :image-height="1024" v-model="category.img"
                                    style="max-width: 253px;">
                            <div slot="activator">
                                <v-avatar size="200px" v-ripple tile v-if="category.img.imageURL">
                                    <img :src="category.img.imageURL" alt="Изображение для категории"/>
                                </v-avatar>
                                <v-avatar size="200px" v-ripple tile v-else-if="!category.img.imageURL && category.img">
                                    <v-img :src="rootURL + category.img" aspect-ratio="1">
                                        <v-layout
                                            slot="placeholder"
                                            fill-height
                                            align-center
                                            justify-center
                                            ma-0>
                                            <v-progress-circular indeterminate color="grey"></v-progress-circular>
                                        </v-layout>
                                    </v-img>
                                </v-avatar>
                                <v-avatar size="200px" v-ripple class="grey lighten-3" tile v-else>
                                    <img src="/static/img/media/image_blank.svg"
                                         alt="Нажмите чтобы добавить картинку для категории"/>
                                </v-avatar>
                            </div>
                        </upload-img>
                        <v-flex xs5 offset-xs1>
                            <v-subheader class="pa-0">emoji (для ботов)</v-subheader>
                            <v-text-field
                                ref="category_emoji"
                                v-model="category.emoji"
                                v-validate="'required'"
                                data-vv-name="emoji"
                                :error-messages="errors.collect('emoji')"
                                single-line
                                solo
                                text
                                required/>
                            <v-subheader class="pa-0">Позиция</v-subheader>
                            <v-text-field
                                mask="###"
                                ref="category_position"
                                v-model="category.position"
                                single-line
                                text
                                solo/>
                            <v-subheader class="pa-0">Статус</v-subheader>
                            <v-checkbox :label="category.status ? 'Включен' : 'Отключен'" v-model="category.status"
                                        class="mt-0"/>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-subheader class="pa-0">Описание</v-subheader>
                    <v-textarea
                        ref="category_description"
                        v-model="category.description"
                        v-validate="'required|max:140'"
                        :error-messages="errors.collect('description')"
                        data-vv-name="description"
                        single-line
                        solo
                        text
                        required
                        counter="140"/>
                </v-flex>
                <v-flex xs12>
                    <v-subheader class="pa-0">Рекомендованный товары к этой категории</v-subheader>
                    <v-combobox
                        solo
                        text
                        multiple
                        small-chips
                        hide-selected
                        item-value="id"
                        item-text="name"
                        :items="products"
                        deletable-chips
                        v-model="category.recommended"
                        label="Выберите необходимое">
                        <template slot="no-data">
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Пусто? Добавьте продукты и попробуйте снова
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-combobox>
                </v-flex>
                <v-flex xs12>
                    <v-subheader class="pa-0">Аттрибуты для товаров категорий</v-subheader>
                    <v-combobox
                        solo
                        text
                        multiple
                        small-chips
                        hide-selected
                        item-value="id"
                        item-text="key"
                        :items="attrs"
                        deletable-chips
                        v-model="category.attrs"
                        label="Выберите необходимое">
                        <template slot="no-data">
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Пусто? Значит закончились или не были добавлены аттрибуты
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-combobox>
                </v-flex>
            </v-form>
            <v-dialog v-model="dialog" persistent max-width="45%">
                <v-card>
                    <v-card-title class="headline">
                        <h4>Подтверждение удаление</h4>
                    </v-card-title>
                    <v-card-text>
                        Категория и все продукты будут удалены! <br/> Вы уверены что хотите этого?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <template v-if="waitDelete">
                            <v-progress-linear indeterminate color="warning" class="mb-0"/>
                        </template>
                        <template v-else>
                            <v-btn color="info" class="v-btn--save" @click="deleteCategory">
                                Продолжить
                            </v-btn>
                            <v-btn color="error" class="v-btn--save" @click="dialog = false">
                                Отменить
                            </v-btn>
                        </template>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </transition>
</template>

<script>
    import config from '../../../config'
    import Category from '../../../api/category'
    import Attr from '../../../api/attr'
    import Product from '../../../api/product'
    import UploadImg from '../../../components/Media/Upload'
    import Loader from '../../../components/Loader/Layout'

    export default {
        name: 'editCategory',
        props: ['categoryId'],
        components: {
            UploadImg,
            Loader
        },
        $_veeValidate: {
            validator: 'new'
        },
        data: () => ({
            loading: false,
            loader: false,
            category: {
                id: 0,
                img: '',
                name: '',
                status: true,
                position: 1,
                description: '',
                recommended: [],
                attrs: []
            },
            rootURL: '',
            attrs: [],
            products: [],
            dialog: false,
            waitDelete: false,
            dictionary: {
                custom: {
                    name: {
                        required: 'Введите название для категории',
                        max: 'Превышено максимальное количество символов в названии'
                    },
                    description: {
                        required: 'Описание не заполнено',
                        max: 'Превышено максимальное количество символов в описании'
                    },
                    emoji: {
                        required: 'Emoji не поставлен'
                    }
                }
            }
        }),
        created () {
            this.rootURL = config.rootPath
            this.$validator.localize('ru', this.dictionary)
        },
        mounted () {
            this.getCategory(this.categoryId)
        },
        methods: {
            getCategory (id) {
                this.loader = true

                Category
                    .getById(id)
                    .then(response => {
                        this.category = response.data.data
                        delete this.category.products
                    })
                    .catch(error => {
                        this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] })
                        this.$router.push({ name: 'categoryRoot' })
                    })
                    .finally(() => this.loader = false)

                Product
                    .getAll()
                    .then(response => this.products = response.data.data)
                    .catch(error => new Error(error))

                Attr
                    .getAll()
                    .then(response => this.attrs = response.data.data)
                    .catch(error => new Error(error))
            },
            sendForm () {
                this.$validator
                    .validateAll()
                    .then(isValid => {
                        if (!isValid) return

                        this.loading = true

                        Category
                            .edit(this.category)
                            .then(response => {
                                response.data.data.products = response.data.data.products_all
                                delete response.data.data.products_all

                                this.category = response.data.data
                                this.$store.commit('updateCategory', response.data)
                                this.$store.commit('showSnackbar', {
                                    text: 'Отлично! Категория отредактировано',
                                    color: 'success'
                                })
                            })
                            .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
                            .finally(() => this.loading = false)
                    })
                    .catch(error => new Error(error))
            },
            deleteCategory () {
                this.waitDelete = true

                Category
                    .delete(this.category.id)
                    .then(response => {
                        this.$store.commit('deleteCategory', { id: this.category.id })
                        this.$store.commit('showSnackbar', {
                            text: response.data.data,
                            color: 'success'
                        })
                        this.$router.push({ name: 'categoryRoot' })
                    })
                    .catch(error => new Error(error))
                    .finally(() => {
                        this.dialog = false
                        this.waitDelete = false
                    })
            }
        },
        beforeRouteLeave (to, from, next) {
            next()
        },
        beforeRouteUpdate (to, from, next) {
            this.category = this.getCategory(to.params.categoryId)
            next()
        }
    }
</script>
